import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../hooks/global/Languages';

export default function TextArea({ value, question, onChange, sourceId }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.toUpperCase();
  const id = question.id + "" + sourceId;

  const { selectTextByLanguage } = useSelectLanguage();

  const handleChange = (event) => {
    onChange?.(question,  event.target.value);
  }


  return (
    <div className="margin-bottom-30">
      <div className="reviewInvite-question reviewInvite-questionTextArea">
        <h3 className="text-left">{selectTextByLanguage(question.text, lng)}</h3>
        <textarea
          id={id}
          name={id}
          onChange={handleChange}
          value={value} // Set the value of the textarea to the provided value from the parent component
        />
      </div>
    </div>
  )
}
